import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {Button} from 'antd';
import {CloseOutlined} from '@ant-design/icons';
import {StyledExpenseDetailsPanel, StyledExpenseDetailsPanelTabs} from './StyledExpenseDetailsPanel';
import ApprovalsTab from '../ExpenseDetailsPanelTabs/ApprovalsTab';
import ExpenseDetailsTab from '../ExpenseDetailsPanelTabs/ExpenseDetailsTab';

const tabKeys = {
  APPROVALS: 'approvals',
  DETAILS: 'details',
};

const {APPROVALS, DETAILS} = tabKeys;

const defaultTabKey = tabKeys.DETAILS;

const ExpenseDetailsPanel = ({
  expense,
  loading,
  onApprove,
  onClose,
  onEdit,
  onInvoiceRemove,
  onReassign,
  onReject,
  onReviewEdit,
  onUpdate,
  tabsProps,
  ...rest
}) => {
  const [t] = useTranslation(['main', 'expenses']);
  const [activeTabKey, setActiveTabKey] = useState(defaultTabKey);

  const trans = (key, props) => t(`expenses:${key}`, props);

  const getLabel = (key) => trans(`expenseDetails.tabs.${key}`);

  useEffect(() => {
    if (activeTabKey !== defaultTabKey) {
      setActiveTabKey(defaultTabKey);
    }
  }, [expense?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const tabProps = {expense, onApprove, onReject};

  const tabs = [
    {
      key: DETAILS,
      label: getLabel(DETAILS),
      children: (
        <ExpenseDetailsTab
          {...tabProps}
          className='expense-details-tab'
          onEdit={onEdit}
          onInvoiceRemove={onInvoiceRemove}
          onUpdate={onUpdate}
        />
      ),
    },
    {
      key: APPROVALS,
      label: getLabel(APPROVALS),
      children: (
        <ApprovalsTab
          {...tabProps}
          onReassign={onReassign}
          onReviewEdit={onReviewEdit}
        />
      ),
    },
  ];

  return (
    <StyledExpenseDetailsPanel {...rest}>
      <StyledExpenseDetailsPanelTabs
        activeKey={activeTabKey}
        items={tabs}
        onChange={setActiveTabKey}
        type='card'
        tabBarExtraContent={{
          right: <Button icon={<CloseOutlined />} type='text' onClick={onClose} />
        }}
        {...tabsProps}
      />
    </StyledExpenseDetailsPanel>
  );
}

ExpenseDetailsPanel.propTypes = {
  expense: PropTypes.object,
  onApprove: PropTypes.func,
  onClose: PropTypes.func,
  onEdit: PropTypes.func,
  onInvoiceRemove: PropTypes.func,
  onReassign: PropTypes.func,
  onReject: PropTypes.func,
  onReviewEdit: PropTypes.func,
  onUpdate: PropTypes.func,
  tabsProps: PropTypes.object,
}

export default ExpenseDetailsPanel;
